import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import { useAuthenticator } from "@aws-amplify/ui-react";

export const ProductContext = createContext();

export const useProductContext = () => useContext(ProductContext);

export function ProductContextProvider({ children }) {
  const existingContext = useContext(ProductContext);

  const { authStatus } = useAuthenticator((context) => [context.user]);

  const initialUserState = {
    authenticated: authStatus === "authenticated",
    personalInfo: {
      firstName: existingContext
        ? existingContext.userState.personalInfo.firstName
        : null,
      lastName: existingContext
        ? existingContext.userState.personalInfo.lastName
        : null,
      email: existingContext
        ? existingContext.userState.personalInfo.email
        : null,
      phone: existingContext
        ? existingContext.userState.personalInfo.phone
        : null,
    },

    skippedDenialLetter: existingContext
      ? existingContext.userState.skippedDenialLetter
      : null,

    summaryClaimInformation: {
      disease: existingContext
        ? existingContext.userState.summaryClaimInformation.disease
        : null,
      coverageDesired: existingContext
        ? existingContext.userState.summaryClaimInformation.coverageDesired
        : null,
      denialReason: existingContext
        ? existingContext.userState.summaryClaimInformation.denialReason
        : null,
      denialDate: existingContext
        ? existingContext.userState.summaryClaimInformation.denialDate
        : null,
      insuranceProvider: existingContext
        ? existingContext.userState.summaryClaimInformation.insuranceProvider
        : null,
      insuranceType: existingContext
        ? existingContext.userState.summaryClaimInformation.insuranceType
        : null,
      coverageState: existingContext
        ? existingContext.userState.summaryClaimInformation.coverageState
        : null,
      appealTimeline: existingContext
        ? existingContext.userState.summaryClaimInformation.appealTimeline
        : null,
    },

    letterReview: existingContext
      ? existingContext.userState.letterReview
      : null,
    disclaimerAgreed: existingContext
      ? existingContext.userState.disclaimerAgreed
      : null,
    paid: existingContext ? existingContext.userState.paid : null,
  };

  const [userState, setUserState] = useState(initialUserState);
  const [pageState, setPageState] = useState({});

  const clearPageState = () => {
    setPageState({});
  };

  return (
    <ProductContext.Provider
      value={{
        userState,
        setUserState,
        pageState,
        setPageState,
        clearPageState,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
}

ProductContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
